"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Class for downloading files
 */
var FileSaver = /** @class */ (function () {
    function FileSaver() {
    }
    /**
     * Download file
     *
     * @param blob for example it can be taken from Response: response.blob()
     * @param name file's name it can be set manually or get from response's Content-Disposition header
     */
    FileSaver.prototype.download = function (blob, name) {
        var _this = this;
        var view = typeof self !== "undefined" && self
            || typeof window !== "undefined" && window;
        if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(blob, name || blob.name);
        }
        else {
            var doc = view.document;
            var save_link_1 = doc.createElementNS("http://www.w3.org/1999/xhtml", "a");
            var can_use_save_link = "download" in save_link_1;
            if (can_use_save_link) {
                var object_url_1 = FileSaver.get_URL(view).createObjectURL(blob);
                setTimeout(function () {
                    save_link_1.href = object_url_1;
                    save_link_1.download = name || blob.name;
                    FileSaver.click(save_link_1);
                    _this.revoke(object_url_1, view);
                });
                return;
            }
            this.fs_error(blob, view);
        }
    };
    FileSaver.is_safari = function (view) {
        return /constructor/i.test(view.HTMLElement) || view.safari;
    };
    FileSaver.is_chrome_ios = function (view) {
        return /CriOS\/[\d]+/.test(view.userAgent);
    };
    FileSaver.prototype.fs_error = function (blob, view) {
        var type = blob.type;
        var force = type === FileSaver.FORCE_SAVEABLE_TYPE;
        var object_url;
        if ((FileSaver.is_chrome_ios(view) || (force && FileSaver.is_safari(view))) && view.FileReader) {
            // Safari doesn't allow downloading of blob urls
            var reader_1 = new FileReader();
            reader_1.onloadend = function () {
                var url = FileSaver.is_chrome_ios(view) ? reader_1.result : reader_1.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
                var popup = view.open(url, '_blank');
                if (!popup)
                    view.location.href = url;
            };
            reader_1.readAsDataURL(blob);
            return;
        }
        // don't create more object URLs than needed
        if (!object_url) {
            object_url = FileSaver.get_URL(view).createObjectURL(blob);
        }
        if (force) {
            view.location.href = object_url;
        }
        else {
            var opened = view.open(object_url, "_blank");
            if (!opened) {
                // Apple does not allow window.open, see:
                // https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
                view.location.href = object_url;
            }
        }
        this.revoke(object_url, view);
    };
    ;
    // only get URL when necessary in case Blob.js hasn't overridden it yet
    FileSaver.get_URL = function (view) {
        return view.URL || view.webkitURL || view;
    };
    FileSaver.prototype.revoke = function (file, view) {
        setTimeout(function () {
            if (typeof file === "string") {
                // file is an object URL
                FileSaver.get_URL(view).revokeObjectURL(file);
            }
            else {
                // file is a File
                file.remove();
            }
        }, FileSaver.ARBITRARY_REVOKE_TIMEOUT);
    };
    FileSaver.click = function (node) {
        var event = new MouseEvent("click");
        node.dispatchEvent(event);
    };
    FileSaver.FORCE_SAVEABLE_TYPE = "application/octet-stream";
    FileSaver.ARBITRARY_REVOKE_TIMEOUT = 1000 * 40;
    return FileSaver;
}());
exports.FileSaver = FileSaver;
//# sourceMappingURL=file-saver.js.map